

export default function cancelScreen() {
  return (
    <div>
      <h1>Paymnet Cancelled</h1>
      <p>
        You payment has been cancelled. Please try again or contact support if
        you have{' '}
      </p>
    </div>
  );
}
